import PropTypes from "prop-types";

const AuthUserPropType = PropTypes.shape({
  email: PropTypes.string,
  uid: PropTypes.string,
});

export default AuthUserPropType;
